import { MessageInfoCursorFragment, MessageInfoFragment } from '@graphql/generated';
import { Box } from '@withjoy/joykit';
import React from 'react';

export type SpamQueueRow = MessageInfoFragment & { cursor: MessageInfoCursorFragment };

export const ROW_ID_PARAM_NAME = 'row';

export const END_OF_QUEUE_MSGS: Array<string | JSX.Element> = [
  `Way to go! You're a spam swatting superhero!`,
  `Another spammer bites the dust!`,
  `Good work! Spam defeated, now we can sleep tight 😇`,
  `Welcome to the bottom! Can I interest you in a snack?`,
  `🪰💥 spam smashed! have a taco 🌮`,
  `Whew, you blocked a lot of spam! Time for a nap 😴🛌`,
  `Spam defeated! But don't let your guard down yet... more is sure to come!`,
  `Thanks for using the Spam Service Center! Come again soon!`,
  // DK Rickroll
  <a
    href="https://dev.withjoy.com/go/dk"
    key={0}
  >
    CLICK FOR TACOS!
  </a>,
  // Giant capybara
  <Box
    as="img"
    src="http://withjoy.com/media/paper-imagine/spamcapybara.png"
    style={{ maxWidth: '100%', width: '300px', margin: '1rem' }}
    key="funnycapybara"
  />,
  `If we had a penny for every spammer you just blocked, we could buy all our employees a pony!`,
  `Deleting 1 spam a day keeps the doctor away!`,
  `Imagine a world without spammers 🥺`,
  `1 message rejected 📧 = 1 taco 🌮`,
];
